import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';


export const getOneAgent=(id)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_ONE_AGENT_START
    })
    await axios.get(`/agents/${id}`)
            .then(response=>dispatch({
                type:actionTypes.GET_ONE_AGENT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_ONE_AGENT_FAIL,
                payload:getMessage(error)
            }))
}